import { DateTime } from "luxon";

export const generateExportFileName = () => {
  const dt = DateTime.now();
  // Format: YYYY-MM-DD-HHmm (24-hour format)
  return `Lots Export ${dt.toFormat("MMM dd yyyy")}.csv`;
};
